import { render } from "./CanDy.vue?vue&type=template&id=4fc8f15e"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CanDy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fc8f15e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fc8f15e', __exports__)) {
    api.reload('4fc8f15e', __exports__)
  }
  
  module.hot.accept("./CanDy.vue?vue&type=template&id=4fc8f15e", () => {
    api.rerender('4fc8f15e', render)
  })

}


export default __exports__